import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const Read = ({ className }) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="14.707"
        height="14.189"
        viewBox="0 0 14.707 14.189"
        fill="currentColor"
    >
        <path d="M0,0H14.707V2.063H0ZM0,4.126H9.192V6.189H0Z" transform="translate(0 8)" />
        <path d="M0,0H14.707V2.063H0ZM0,4.126H12.569V6.189H0Z" />
    </svg>
);

Read.propTypes = propTypes;
Read.defaultProps = defaultProps;

export default Read;
